import * as types from './types';

export default (state, action) => {
  switch (action.type) {
    case types.UPDATE_PAGE_VALID:
      return { ...state, ...action.payload };
    default:
      return { ...state };
  }
};
